var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMicrophoneOff(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.0072 5.58586C24.3977 5.97639 24.3977 6.60955 24.0072 7.00008L10.0072 21.0001C9.61663 21.3906 8.98347 21.3906 8.59294 21.0001C8.20242 20.6096 8.20242 19.9764 8.59294 19.5859L22.5929 5.58586C22.9835 5.19534 23.6166 5.19534 24.0072 5.58586Z",
    fill: "#0071FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0071 4C14.7979 4 13.0071 5.79086 13.0071 8V13.7575L20.5749 6.18966C19.9143 4.89025 18.5646 4 17.0071 4Z",
    fill: "#0071FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0071 11.4144L13.4987 18.9228C14.1786 20.1608 15.4949 21 17.0071 21C19.2162 21 21.0071 19.2091 21.0071 17V11.4144Z",
    fill: "#0071FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M24.007 17C24.007 16.4477 23.5593 16 23.007 16C22.4548 16 22.007 16.4477 22.007 17C22.007 17.9889 21.7138 18.9556 21.1644 19.7779C20.615 20.6001 19.8341 21.241 18.9205 21.6194C18.3103 21.8721 17.6593 22.0002 17.0052 22C16.6798 21.9999 16.3538 21.968 16.0316 21.9039C15.0617 21.711 14.1708 21.2348 13.4715 20.5355C13.081 20.145 12.4478 20.145 12.0573 20.5355C11.6668 20.9261 11.6668 21.5592 12.0573 21.9497C13.0363 22.9287 14.2835 23.5954 15.6414 23.8655C15.7629 23.8897 15.8849 23.9106 16.0071 23.9282L16.0071 28.2222C16.0071 28.6518 16.4548 29 17.0071 29C17.5594 29 18.0071 28.6518 18.0071 28.2222V23.9282C18.5807 23.8454 19.1447 23.6913 19.6858 23.4672C20.9649 22.9373 22.0582 22.0401 22.8273 20.889C23.5965 19.7378 24.007 18.3845 24.007 17Z",
    fill: "#0071FF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrophoneOff);
export default __webpack_public_path__ + "static/media/microphoneOff.8e4d4bdc51eda2b3224254b3433e5d44.svg";
export { ForwardRef as ReactComponent };